module.exports = __webpack_public_path__ + "static/media/region-dark.ade81534.webp";